module.exports = __webpack_public_path__ + "static/paintingGif-233f673730ef972d6ed605753674eee1.gif";